import Model from '../orm/Model'

import Student from './Student'
import Coordinate from './Coordinate'

export default class Attendance extends Model {

    static entity = 'attendance'

    static fields() {
        return {
            id: this.attr(null),
            attendable_id: this.attr(null),
            attendable_type: this.attr(null),
            school_id: this.attr(null),
            student: this.belongsTo(Student, 'student_id'),
            student_id: this.attr(null),
            location_id: this.attr(null),
            status: this.attr(0),
            enter: this.attr(null),
            exit: this.attr(null),
            percentage: this.attr(0),
            activity: this.array([], ['event', 'created_at']),
            coordinates: this.hasMany(Coordinate, 'attendance_id'),
            overrides: this.obj({}, 'old_status user { first_name last_name }'),
            lock: this.attr(0),
            finished: this.attr(0),
            meets: this.attr(false),
            created_at: this.attr(null)
        }
    }

    static graphql = {
        all: {
            parameters: {
                student_uuid: 'String!',
                uuid: 'String!',
                type: 'String!'
            },
            include: ['coordinates', 'activity', 'overrides'],
            exclude: ['meets']
        },
        update: {
            type: 'updateAttendance',
            parameters: {
                id: 'Int!',
                status: 'Int!'
            },
            include: ['overrides'],
            exclude: ['meets']
        }
    }
}